import get from 'lodash/get';
import has from 'lodash/has';
import isNull from 'lodash/isNull';
import map from 'lodash/map';

export const getColorsConfig = (colorConfig) => {

  if(!colorConfig) {
    return "inherit";
  }

  if (colorConfig.type == 'solid') {
    var colorRgb = colorConfig
    return `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`
  }

  if (colorConfig.type == 'gradient') {
    var gradientType = get(colorConfig, 'gradientType', 'Linear')
    const degree = get(colorConfig, 'degree')
    const colorStrings = map(get(colorConfig, 'gradientColors'), color => {
      const rgb = `rgb(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
      const position = `${color.position}%`;
      return `${rgb} ${position}`;
    });
    let gradientColor = colorStrings.join(', ');

    
    switch (gradientType) {
      case 'Linear':
        gradientColor = `linear-gradient(${degree}deg, ${gradientColor} )`
        break;

      case 'Radial':
        gradientColor = `radial-gradient(circle at 50% 50%, ${gradientColor} )`
        break;

      case 'Angular':
        gradientColor = `conic-gradient(from ${degree}deg at 50% 50%, ${gradientColor} )`
        break;

      default:
        gradientColor = `linear-gradient(${degree}deg, ${gradientColor} )`
        break;
    }

    return gradientColor;
  }

  if(colorConfig &&  has(colorConfig, 'rbg') && isNull(colorConfig.rbg)) {
    return `rgba(0,0,0,0)`
  }

  var colorRgb = colorConfig.color || colorConfig

  return colorRgb ? `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})` : `rgba(255, 255, 255, 1)`
}
